<template>
  <v-app id="app">

    <div id="header">
      <Header
        v-show="this.$route.name !== 'Home'"
      ></Header>
    </div>

    <div id="main">
      <router-view></router-view>
    </div>

    <Menu>
    </Menu>

    <!-- 登録完了通知のトースト用 -->
    <v-snackbar
      v-model="$store.state.task.isShowToast"
      top
      timeout="-1"
    >
      <div id="toast">
        Completed.
      </div>
    </v-snackbar>

  </v-app>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Menu,
    Header
  },
  methods : {
    ...mapMutations({
      syncStorageData: 'task/syncStorageData'
    }),
  },
  created () {
    this.syncStorageData()
  },
}
</script>

<style lang="scss">
#app {
  font-family: "ヒラギノ角ゴシック Pro", "Hiragino Kaku Gothic Pro",
  メイリオ, Meiryo, Osaka, "ＭＳ Ｐゴシック",
  "MS PGothic", sans-serif;
}
#header {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 36px;
  z-index: 100;
}
#main {
  position: fixed;
  top: 36px;
  left: 0px;
  width: 100vw;
  // height: calc(100vh - 36px - 52px);
  height: 100vh;
  overflow: scroll;
}
#main {
    -ms-overflow-style: none;    /* IE, Edge 対応 */
    scrollbar-width: none;       /* Firefox 対応 */
}
#main::-webkit-scrollbar {  /* Chrome, Safari 対応 */
    display:none;
}
#toast{
  z-index: 999;
}
</style>
